"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = require("@angular/core");
var base_provider_typeahead_service_1 = require("./base-provider-typeahead-service");
var BhtpTourTypeaheadService = (function (_super) {
    __extends(BhtpTourTypeaheadService, _super);
    function BhtpTourTypeaheadService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.typeAsString = 'Tour Operator';
        return _this;
    }
    return BhtpTourTypeaheadService;
}(base_provider_typeahead_service_1.BhtpBaseProviderTypeaheadService));
BhtpTourTypeaheadService = __decorate([
    core_1.Injectable()
], BhtpTourTypeaheadService);
exports.BhtpTourTypeaheadService = BhtpTourTypeaheadService;
//# sourceMappingURL=D:/a/1/s/typeahead/src/tour-typeahead-service.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/typeahead/src/tour-typeahead-service.js